import { createApp } from "vue";
import App from "./App.vue";
import Antd from "ant-design-vue";
import Router from "./router";
import "@/flexible/index";
import "ant-design-vue/dist/reset.css";
import { i18n, registerDirectives } from "./utils/i18n.js"
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { createPinia } from "pinia";
import { setRouter } from "@/axios/index";
import "@/styles/login.scss";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// 动态加载 CSS 文件
const theme = import.meta.env.VITE_THEME;

if (theme === "dxp") {
  import("./dxp.css");
}

setRouter(Router) // 传递 router
const app = createApp(App);
registerDirectives(app)
app.use(Router);
app.use(i18n);
app.use(Antd);
app.use(pinia);
app.mount("#app");
